// User is logged
export const isLoggedIn = (state) => !!state.token

// User status
export const status = (state) => state.errors

// User token
export const token = (state) => state.token

// User data object
export const user = (state) => state.user
